// Helper function for creating an IntersectionObserver to watch for the presence of an individual element within a
//   scrollable container. This is useful for implementing infinite scrolling, where scrolling to the end of the
//   container should trigger the incrementing of the page.
// If the scrollable container or child element is not found, no IntersectionObserver is created, and null is returned.
// If instantiation of the IntersectionObserver succeeds, the observer is returned to allow cleanup.
export const instantiateScrollableObserver = (
  scrollContainerClassName: string,
  childElementClassName: string,
  callback: IntersectionObserverCallback
): IntersectionObserver | null => {
  const scrollableContainer = document.querySelector(
    `.${scrollContainerClassName}`
  );

  if (!scrollableContainer) {
    return null;
  }

  const childElement = document.querySelector(`.${childElementClassName}`);

  if (!childElement) {
    return null;
  }

  const observer = new IntersectionObserver(callback, {
    root: scrollableContainer,
    rootMargin: "0px"
  });

  observer.observe(childElement);

  return observer;
};
